import { Activity } from '@/types';

export const mockActivities: Activity[] = [
  {
    id: 'act-1',
    projectId: '1',
    name: 'Site Survey & Geotechnical Analysis',
    description: 'Comprehensive site investigation including soil analysis and environmental assessment',
    assignedTo: 'mock-user-1',
    stage: 0,
    status: 'completed',
    isRequired: true,
    dueDate: new Date('2024-02-15'),
    dateCompleted: new Date('2024-02-10'),
    comments: [],
    createdAt: new Date('2024-01-10'),
    updatedAt: new Date('2024-02-10')
  },
  {
    id: 'act-2',
    projectId: '1',
    name: 'Concept Design Development',
    description: 'Initial architectural concepts and space planning',
    assignedTo: 'mock-user-2',
    stage: 1,
    status: 'in-progress',
    isRequired: true,
    dueDate: new Date('2024-03-30'),
    dateCompleted: undefined,
    comments: [],
    createdAt: new Date('2024-02-15'),
    updatedAt: new Date('2024-03-01')
  },
  {
    id: 'act-3',
    projectId: '1',
    name: 'Planning Permission Application',
    description: 'Submit detailed planning application to local authority',
    assignedTo: 'mock-user-3',
    stage: 2,
    status: 'not-started',
    isRequired: true,
    dueDate: new Date('2024-04-15'),
    dateCompleted: undefined,
    comments: [],
    createdAt: new Date('2024-03-01'),
    updatedAt: new Date('2024-03-01')
  },
  {
    id: 'act-4',
    projectId: '2',
    name: 'Heritage Impact Assessment',
    description: 'Detailed assessment of impact on heritage building',
    assignedTo: 'mock-user-1',
    stage: 0,
    status: 'completed',
    isRequired: true,
    dueDate: new Date('2024-03-15'),
    dateCompleted: new Date('2024-03-12'),
    comments: [],
    createdAt: new Date('2024-02-15'),
    updatedAt: new Date('2024-03-12')
  },
  {
    id: 'act-5',
    projectId: '2',
    name: 'Conservation Strategy',
    description: 'Development of conservation approach for Victorian features',
    assignedTo: 'mock-user-2',
    stage: 1,
    status: 'in-progress',
    isRequired: true,
    dueDate: new Date('2024-04-30'),
    dateCompleted: undefined,
    comments: [],
    createdAt: new Date('2024-03-15'),
    updatedAt: new Date('2024-03-20')
  }
];